import React from 'react';
import { Col, Container, Row, Stack } from 'react-bootstrap';
import Footer from '../../component/Footer';
import Header from '../../component/header';

const Main = () => {
	return (
		<>
			<Header />
			<Container fluid className='landing'>
				<Row className='landing_box'>
					<Col className='landing_text'>1</Col>
					<Col className='landing_text'>2</Col>
					<Col className='landing_text'>3</Col>
				</Row>
			</Container>
			<Footer />
		</>
	);
};

export default Main;
